import { useQuery } from 'react-query';

import { metaDataQueryKeys } from '../QueryKeys';
import useApiHelper from '../../hooks/useApiHelper';
import { IMetadata } from '../../types/Metadata/Metadata';
import { IDefaultResponseWithData } from '../../types/system/DefaultResponse';

export default function useMetadata() {
  const { get } = useApiHelper();

  const defaultValues = useQuery({
    queryKey: metaDataQueryKeys.defaultValues(),
    queryFn: () =>
      get<IDefaultResponseWithData<IMetadata>>('/v1/utilities/defaults').then(
        (res) => res.data.data
      ),
  });

  const features = useQuery({
    queryKey: metaDataQueryKeys.features(),
    queryFn: () =>
      get<IDefaultResponseWithData<IMetadata>>('/v1/utilities/features').then(
        (res) => res.data.data
      ),
    staleTime: Infinity,
    cacheTime: Infinity,
    refetchInterval: false,
  });

  return {
    defaultValues,
    features,
  };
}
